module.exports = "@media only screen and (min-width: 480px) {\n  .content {\n    padding: 0 30px; } }\n\n/* Small Devices, Tablets */\n\n@media only screen and (min-width: 768px) {\n  .content {\n    padding-left: 25%;\n    width: 50%; }\n  .landing-page .background-blur {\n    width: 50%; }\n  .landing-page .background-blur .background2 {\n    width: 200%; } }\n\n@media only screen and (min-aspect-ratio: 1 / 1) {\n  .badge-container {\n    margin: 20px 0; }\n    .badge-container h1, .badge-container h3 {\n      display: inline-block; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hello/hello.breakpoints.scss
// module id = ./src/app/hello/hello.breakpoints.scss
// module chunks = main